import type { ROLE } from 'types/Role.ts';

export const POC_POD_TEMPLATES = ['unity_template', 'cargowise_template'] as const;
export type POC_POD_TEMPLATE = (typeof POC_POD_TEMPLATES)[number];

export type UserRow = {
  id: string;
  logistics_ex_id: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  last_action_at: string | null;
  is_group: boolean;
  owner_id: string | null;
  email: string;
  role: ROLE;
  name: string;
  organization_id: string | null;
  company_name: string | null;
  company_website: string | null;
  vat_number: string | null;
  sso_only: boolean;
  address: string | null;
  phone: string | null;
  timezone: string | null;
  preferred_date_format: string | null;
  // view and computed fields
  group_id: string | null;
  group_name: string | null;
  group_role: string | null;
  trackingmore_id: string | null;
  poc_pod_template: POC_POD_TEMPLATE | null;
};

export type UserRowInsert = Partial<UserRow> & NonNullable<Pick<UserRow, 'owner_id' | 'email' | 'role' | 'name'>>;

export type UserRowUpdate = Omit<Partial<UserRow>, 'id'>;

export type User = UserRow & {
  owner_logistics_ex_id: string | null;
  isActive: boolean;
};

// `is_support_admin` is true while the user holds an active support grant for the ADMINISTRATOR role,
// which temporarily confers super-admin status (see UserRepository.getAugmented / UserService.isSuperadmin).
export type AuthedUser = UserRow & { isActive: boolean; is_support_admin?: boolean };

export type UserBC = {
  organisationId: string;
  id: string;
  ownerId: string;
  emailHash: string;
  isActive: boolean;
  isGroup: boolean;
};
